import styled from 'styled-components';
export const Wrapper = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  .text {
    text-align: right;
    width: 120px;
  }
  .text h2 {
    color: #343c6a;
    font-size: 14px;
    font-weight: 500;
    line-height: 14px;
  }
  .text p {
    color: #8490a5;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    margin: 0px;
  }
  .img {
    width: 46px;
    height: 46px;
    border: none;
    background-color: transparent;
    outline: none;
  }
  .img img {
    cursor: pointer;
    width: 100%;
    border-radius: 50%;
    height: 100%;
  }
`;

export const Content = styled.div`
  /* width: 100%; */
  padding: 0 30px;
  height: var(--navbar-height);
  box-shadow: 0 5px 5px rgba(182, 182, 182, 0.75);
  background-color: var(--navbar-background);
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Action = styled.div`
  display: flex;
  align-items: center;
  padding: 0 20px;
  height: 58px;
  border-radius: 12.62px;
  justify-content: end;
  gap: 20px;
  color: #a4a4a4;
`;
export const UserProfile = styled.div`
  display: flex;
  align-items: center;
  color: #a8a8a8;
  /* max-width: 160px; */
  text-align: right;
  line-height: 16px;
  column-gap: 15px;
  cursor: pointer;
`;
UserProfile.Title = styled.span`
  color: #1d2435;
`;
export const LogoutButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #3380ff;
`;
export const LogoContainer = styled.div`
  width: 30px;
  height: 30px;
`;
export const Username = styled.div`
  font-family: 'Inter', sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #1d2435;
`;
export const Userimage = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #f5f7fa;
`;
export const Title = styled.span`
  color: #1a2132;
  font-size: 20px;
  text-transform: capitalize;
  font-weight: 700;
  margin: 0;
`;
export const SearchContainer = styled.div`
  width: 200px;
  display: flex;
  align-items: center;
  padding: 0 8px;
  /* min-height: 35px; */
  border-radius: 6px;
  border: 1px solid #f0f0f0;
  input {
    border: none;
    max-width: 100%;
    outline: none;
    min-height: 35px;
    margin-left: 8px;
    ::placeholder {
      color: #afb2b8;
      font-size: 13px;
    }
  }
`;

export const VerticalLine = styled.div`
  width: 2px;
  height: 20px;
  background-color: #d3d3d3;
`;
export const NavbarTitle = styled.h1`
  padding-top: 15px;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  color: #343c6a;
`;
